{
  "ConfigureAgents_Add_Title": "Aggiungi nuovo agente",
  "ConfigureAgents_Modify_Title": "Modificare l'agente",
  "ConfigureAgents_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "ConfigureAgents_PromptConfirm": "Sì",
  "ConfigureAgents_PromptCancel": "Annullamento",
  "ConfigureAgents_Tabs_Details": "Dettagli agente",
  "ConfigureAgents_Tabs_Advanced": "Avanzato",
  "ConfigureAgents_Tabs_Omnichannel": "Omnichannel",
  "ConfigureAgents_Footer_Help": "Aiuto?",
  "ConfigureAgents_Footer_Submit": "Risparmiare",
  "ConfigureAgents_Footer_Cancel": "Annullamento",
  "NAME": "ConfigureAgents"
}